import React from 'react';
export function SourceNote() {
  return <section aria-labelledby="source-note-heading" className="mt-14 border-l-2 border-rule-strong bg-paper-tint px-6 py-6" data-id="element-82" data-mp="119iyrc9r5c7q">
      <h2 id="source-note-heading" className="font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-ink" data-id="element-83" data-mp="14ob8ua3oatph">
        Source Note
      </h2>
      <div className="mt-4 space-y-3" data-id="element-84" data-mp="19ks73x4l6oga">
        <p className="font-sans text-[13.5px] leading-[1.7] text-ink-soft" data-id="element-85" data-mp="cxol6uuu2s6u">
          This report is based on court records and legal documents associated with the proceedings
          described above.
        </p>
        <p className="font-sans text-[13.5px] leading-[1.7] text-ink-soft" data-id="element-86" data-mp="lwimuzn0u8r9">
          Statements attributed to the defense memorandum represent the position presented on behalf
          of Don Callaway and should not be interpreted as independent findings of fact by the court.
        </p>
        <p className="font-sans text-[13.5px] leading-[1.7] text-ink-soft" data-id="element-87" data-mp="3ucbtmmrjw5v4">
          The report distinguishes between allegations, arguments presented by the parties,
          procedural decisions and findings contained in court orders.
        </p>
      </div>
    </section>;
}